import { render } from "./AccountInfo.vue?vue&type=template&id=6efaf3f6&scoped=true"
import script from "./AccountInfo.vue?vue&type=script&lang=js"
export * from "./AccountInfo.vue?vue&type=script&lang=js"

import "./AccountInfo.vue?vue&type=style&index=0&id=6efaf3f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6efaf3f6"]])

export default __exports__